<style>

</style>
<template>
    <echart ref="echart" :options="chart.options" ng-if="chart && chart.options && chart.render" :autoresize="true" :rendered="rendered()" :finished="rendered()" style="width: 100%;"/>
</template>
<script>
export default {
    props:['chart'],
    data: function() {
      return {};
    },
    methods: {
      rendered: function() {
        this.chart.refs = this.$refs;
      }
    },
    computed: {

    },
    components: {
      
    },
    mounted: function() {
      this.chart.refs = this.$refs;
      console.log(this.chart.refs);
    }
}

</script>
